<template>
    <div
        v-if="!valid"
        class="company__icon"
        style="background: #7063d2; opacity: 0.7;width:100px; height:100px;"
    >
        <p class="company__paragraph">{{ name[0] }}{{ name[1] }}</p>
    </div>
    <div v-else class="company__icon">
        <img :src="logo" :alt="name" @error="valid = false" />
    </div>
</template>

<script>
export default {
    props: ["logo", "name"],
    data() {
        return {
            valid: true
        };
    }
};
</script>
